import Button from 'core/components/buttons/Button'
import Icon from 'core/components/icons/Icon'

export const OUT_OF_DATE_TITLE = 'Everlance application is out of date'
export const OUT_OF_DATE_DESCRIPTION =
  'You need to reload this page to continue using it without unexpected behaviour.'

const OutOfDateScreen = () => (
  <div className="flex justify-center items-center gap-5 w-screen h-screen flex-col text-center">
    <Icon
      name="exclamation-mark"
      color="text-white"
      className="bg-dark-4 rounded-full p-1"
      size={36}
    />
    <h1 className="text-dark-4 m-0">{OUT_OF_DATE_TITLE}</h1>
    <div className="max-w-80">{OUT_OF_DATE_DESCRIPTION}</div>
    <Button variant="primary" onClick={() => window.location.reload()}>
      Reload
    </Button>
  </div>
)

export default OutOfDateScreen
